<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">
<path fill="currentColor" d="M6,3.07V10H4.5C3.119,10,2,11.119,2,12.5C2,13.881,3.119,15,4.5,15S7,13.881,7,12.5V5.913l6-0.943V9h-1.5
	C10.119,9,9,10.119,9,11.5c0,1.381,1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5V1.812L6,3.07z"/>
</svg>
